//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UMUM from  '../../../library/umum'
import WILAYAH from  '../../../library/getWilayah'
import FETCHING from  '../../../library/fetching'
import uniqid from 'uniqid';

export default {
  data() {
    return {

        form : {
            id : '',
            m_ipd_variabel : '',
            uraian : '',
            keterangan: '',
            createdAt : '',
            des_kel : '',
            kecamatan : '',
        },


        pertanyaan : {
            id : '',
            m_ipd_indikator : '',
            uraian : '',
            createdAt : '',

        },





        list_data : [],
        page_limit : 8,
        page_first: 1,
        page_last: 0,
        cari_value: "",
        cek_load_data : true,



        mdl_add: false,
        mdl_edit: false,
        mdl_hapus : false,
        btn_add: false,

        list_data_pertanyaan : [],

        mdl_view_pertanyaan: false,
        mdl_add_pertanyaan: false,
        mdl_edit_pertanyaan: false,
        mdl_hapus_pertanyaan : false,



        disable_kec : false,
        disable_des : false,

        UMUM : UMUM,
        FETCHING : FETCHING,
    }
  },
  methods: {


    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_srv_ipd_master_indikator + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              page_limit : this.page_limit,
              cari_value: this.cari_value
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jmlData;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },


    addData : function(number) {
        this.form.id = uniqid();
        this.form.keterangan = document.getElementById("editor").value;
        console.log(this.form.id)
        this.form.createdAt = UMUM.NOW()
        fetch(this.$store.state.url.URL_srv_ipd_master_indikator + "addData", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView();
        });

        // console.log(document.getElementById("editor").value)
    },


    editData : function(){
        this.form.keterangan = document.getElementById("editor").value;
      fetch(this.$store.state.url.URL_srv_ipd_master_indikator + "editData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    removeData : function(E){
      fetch(this.$store.state.url.URL_srv_ipd_master_indikator + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
      });

    },
    selectData : function(data){

            this.form.id = data.id;
            this.form.m_ipd_variabel = data.m_ipd_variabel;
            this.form.uraian = data.uraian;
            this.form.keterangan= data.keterangan;
            this.form.createdAt = data.createdAt;


            this.pertanyaan.m_ipd_indikator = data.id
            this.getView_pertanyaan();
    },

    emptytData : function(data){
             this.form.id = '';
            this.form.m_ipd_variabel = '';
            this.form.uraian = '';
            this.form.keterangan= null;
            this.form.createdAt = '';
    },






    getView_pertanyaan : function(){
      fetch(this.$store.state.url.URL_srv_ipd_master_indikator + "view_pertanyaan", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              m_ipd_indikator: this.pertanyaan.m_ipd_indikator,
              tahun : 2022,

          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data_pertanyaan = res_data;
              // console.log(res_data);
      });
    },


    addData_pertanyaan : function(number) {
        this.pertanyaan.id = uniqid();
        this.pertanyaan.createdAt = UMUM.NOW()
        fetch(this.$store.state.url.URL_srv_ipd_master_indikator + "addData_pertanyaan", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.pertanyaan)
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView_pertanyaan();
        });

        // console.log(document.getElementById("editor").value)
    },


    editData_pertanyaan : function(){
      fetch(this.$store.state.url.URL_srv_ipd_master_indikator + "editData_pertanyaan", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.pertanyaan)
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView_pertanyaan();
      });
    },

    removeData_pertanyaan : function(E){
      fetch(this.$store.state.url.URL_srv_ipd_master_indikator + "removeData_pertanyaan", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.pertanyaan)
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView_pertanyaan();
      });

    },
    selectData_pertanyaan : function(data){

            this.pertanyaan.id = data.id;
            this.pertanyaan.m_ipd_indikator = data.m_ipd_indikator;
            this.pertanyaan.uraian = data.uraian;
            this.pertanyaan.createdAt = data.createdAt;
    },


    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        },


        tunggu : async function(){

            const body = {desa : ''};
            this.$store.state.listVariabel  = await FETCHING.FETCH_POST(this.$store.state.url.URL_srv_ipd_master_variabel + "list", body)


        },


    // ====================================== PAGINATE ====================================







  },

  mounted () {

    this.tunggu()
    this.getView();
 
  },
}
